import {AppProps} from "../App";
import BrauBevLogo from "../components/BrauBev/logo/BrauBevLogo";
import {PdfDataService} from "../services/PdfData.service";
import React from "react";
import BillResult from "../components/billResult/BillResult";
import BillEntry, {BillEntryProps} from "../components/billEntry/BillEntry";
import BoothPreview from "../components/boothPreview/BoothPreview";

const CompleteBrauBevView = (props: AppProps) => {

    function renderBillEntries(billEntries: BillEntryProps[], style?: any): any {
        let elem: any[] = [];
        for(let entry of billEntries) {
            elem.push(<BillEntry {...entry} style={style} />)
        }
        return elem;
    }

    props.boothEntry.costInfo = props.billData.areaCostDisclaimer;
    props.boothEntry.disclaimer = props.billData.labelCostDisclaimer;

    return (
        <div className="Braubev-Pdf">
            <div className="Content">
                <BrauBevLogo provider={"BrauBeviale.com"} isSmall={true} date={props.date}/>
                <div className="Sub-Header">
                    <h2>{props.billData.labelBoothComplete + " " + PdfDataService.getDateString("de-DE")}</h2>
                </div>
                <div className="CostHeader">{props.boothHeader.toUpperCase()}</div>
                {renderBillEntries([props.boothEntry], {marginBottom: "40px"})}
                <div className="CostHeader">{props.billEntryHeader}</div>
                {renderBillEntries(props.billEntries)}
                <BillResult {...props.billResult}/>
            </div>
            <BoothPreview sign={true} column={true} useOvergrowth={false}/>
            <div className="BillDisclaimerWrapper">
                <div className="BillDisclaimer">
                    {props.disclaimer}
                </div>
            </div>
        </div>
    )
}

export default CompleteBrauBevView;